const initialState = {
  request: false,
  data: [],
  error: false,
}
// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PRODUCT_REQUEST':
      return {
        ...state,
        request: true,
        error: false,
      }
    case 'GET_PRODUCT_RESPONSE':
      return {
        ...state,
        request: false,
        data: action.payload.data,
        error: false,
      }
    case 'GET_PRODUCT_ERROR':
      return {
        ...state,
        request: true,
        error: action.payload,
      }
    default:
      return state
  }
};
export const productRequest = state => state.request
export const productData = state => state.data
export const productError = state => state.error
